import styled from 'styled-components';

export const CalendarDaySC = styled.div`
  width: 100%;
  height: 100%;
  background-color: #62ab81;
`;
